// src/types/generated.ts
var MessageRole = /* @__PURE__ */ ((MessageRole2) => {
  MessageRole2["System"] = "System";
  MessageRole2["User"] = "User";
  MessageRole2["Assistant"] = "Assistant";
  MessageRole2["Tool"] = "Tool";
  return MessageRole2;
})(MessageRole || {});
var RegionPreference = /* @__PURE__ */ ((RegionPreference2) => {
  RegionPreference2["EU"] = "EU";
  RegionPreference2["US"] = "US";
  RegionPreference2["Asia"] = "Asia";
  return RegionPreference2;
})(RegionPreference || {});
var BaseModelId = /* @__PURE__ */ ((BaseModelId2) => {
  BaseModelId2["ClaudeOpus41"] = "claude-opus-4.1";
  BaseModelId2["Claude35Sonnet"] = "claude-3.5-sonnet";
  BaseModelId2["ClaudeSonnet4"] = "claude-sonnet-4";
  BaseModelId2["Claude37SonnetThinking"] = "claude-3.7-sonnet-thinking";
  BaseModelId2["GptOss120b"] = "gpt-oss-120b";
  BaseModelId2["Gpt4o"] = "gpt-4o";
  BaseModelId2["Gpt4oMini"] = "gpt-4o-mini";
  BaseModelId2["Gpt5Mini"] = "gpt-5-mini";
  BaseModelId2["Gpt5Nano"] = "gpt-5-nano";
  BaseModelId2["Gpt5Image"] = "gpt-5-image";
  BaseModelId2["Gpt5ImageMini"] = "gpt-5-image-mini";
  BaseModelId2["Gpt51"] = "gpt-5.1";
  BaseModelId2["Gpt51Chat"] = "gpt-5.1-chat";
  BaseModelId2["Gpt51Codex"] = "gpt-5.1-codex";
  BaseModelId2["Grok4"] = "grok-4";
  BaseModelId2["Grok3Mini"] = "grok-3-mini";
  BaseModelId2["Gemini15Pro"] = "gemini-1.5-pro";
  BaseModelId2["Gemini20Flash"] = "gemini-2.0-flash";
  BaseModelId2["Gemini25Flash"] = "gemini-2.5-flash";
  BaseModelId2["Gemini25Pro"] = "gemini-2.5-pro";
  BaseModelId2["Gemini25FlashLite"] = "gemini-2.5-flash-lite";
  BaseModelId2["Gemini25FlashImagePreview"] = "gemini-2.5-flash-image-preview";
  BaseModelId2["Gemini25FlashImage"] = "gemini-2.5-flash-image";
  BaseModelId2["GptOss20b"] = "gpt-oss-20b";
  BaseModelId2["DolphinMistral24bVeniceEdition"] = "dolphin-mistral-24b-venice-edition";
  BaseModelId2["Llama3370bInstruct"] = "llama-3.3-70b-instruct";
  BaseModelId2["DeepSeekR1"] = "deepseek-r1";
  BaseModelId2["KimiK2"] = "kimi-k2";
  BaseModelId2["ClaudeOpus45"] = "claude-opus-4.5";
  BaseModelId2["ClaudeSonnet45"] = "claude-sonnet-4.5";
  BaseModelId2["ClaudeHaiku45"] = "claude-haiku-4.5";
  BaseModelId2["Gpt52"] = "gpt-5.2";
  BaseModelId2["Gpt52Pro"] = "gpt-5.2-pro";
  BaseModelId2["O3"] = "o3";
  BaseModelId2["O3Mini"] = "o3-mini";
  BaseModelId2["Gemini3ProPreview"] = "gemini-3-pro-preview";
  BaseModelId2["Gemini3FlashPreview"] = "gemini-3-flash-preview";
  BaseModelId2["ClaudeOpus47"] = "claude-opus-4.7";
  BaseModelId2["ClaudeSonnet46"] = "claude-sonnet-4.6";
  BaseModelId2["Gpt55"] = "gpt-5.5";
  BaseModelId2["Gpt55Pro"] = "gpt-5.5-pro";
  BaseModelId2["Gpt54Mini"] = "gpt-5.4-mini";
  BaseModelId2["Gpt54Nano"] = "gpt-5.4-nano";
  BaseModelId2["Gpt54Image2"] = "gpt-5.4-image-2";
  BaseModelId2["Gpt53Codex"] = "gpt-5.3-codex";
  BaseModelId2["Gpt53Chat"] = "gpt-5.3-chat";
  BaseModelId2["Gemini31ProPreview"] = "gemini-3.1-pro-preview";
  BaseModelId2["Gemini31FlashImagePreview"] = "gemini-3.1-flash-image-preview";
  BaseModelId2["Gemini31FlashLite"] = "gemini-3.1-flash-lite";
  BaseModelId2["Grok43"] = "grok-4.3";
  BaseModelId2["Llama4Maverick"] = "llama-4-maverick";
  BaseModelId2["KimiK26"] = "kimi-k2.6";
  BaseModelId2["DeepSeekV4Pro"] = "deepseek-v4-pro";
  BaseModelId2["O4Mini"] = "o4-mini";
  BaseModelId2["GptOss120bFree"] = "gpt-oss-120b-free";
  BaseModelId2["GptOss20bFree"] = "gpt-oss-20b-free";
  BaseModelId2["DolphinMistral24bVeniceEditionFree"] = "dolphin-mistral-24b-venice-edition-free";
  BaseModelId2["Llama3370bInstructFree"] = "llama-3.3-70b-instruct-free";
  BaseModelId2["DeepSeekR1Free"] = "deepseek-r1-free";
  BaseModelId2["KimiK2Free"] = "kimi-k2-free";
  return BaseModelId2;
})(BaseModelId || {});
var ModelCapability = /* @__PURE__ */ ((ModelCapability2) => {
  ModelCapability2["Text"] = "Text";
  ModelCapability2["Vision"] = "Vision";
  ModelCapability2["Tools"] = "Tools";
  ModelCapability2["StructuredOutput"] = "StructuredOutput";
  ModelCapability2["Streaming"] = "Streaming";
  ModelCapability2["WebSearch"] = "WebSearch";
  ModelCapability2["ImageGeneration"] = "ImageGeneration";
  return ModelCapability2;
})(ModelCapability || {});
var ProviderType = /* @__PURE__ */ ((ProviderType2) => {
  ProviderType2["Anthropic"] = "Anthropic";
  ProviderType2["OpenAI"] = "OpenAI";
  ProviderType2["Google"] = "Google";
  ProviderType2["Azure"] = "Azure";
  ProviderType2["OpenRouter"] = "OpenRouter";
  return ProviderType2;
})(ProviderType || {});
var ReasoningFormat = /* @__PURE__ */ ((ReasoningFormat2) => {
  ReasoningFormat2["Effort"] = "Effort";
  ReasoningFormat2["MaxTokens"] = "MaxTokens";
  return ReasoningFormat2;
})(ReasoningFormat || {});
var ReasoningSupport = /* @__PURE__ */ ((ReasoningSupport2) => {
  ReasoningSupport2["None"] = "None";
  ReasoningSupport2["Mandatory"] = "Mandatory";
  ReasoningSupport2["Optional"] = "Optional";
  return ReasoningSupport2;
})(ReasoningSupport || {});
export {
  BaseModelId,
  MessageRole,
  ModelCapability,
  ProviderType,
  ReasoningFormat,
  ReasoningSupport,
  RegionPreference
};
//# sourceMappingURL=index.js.map